import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/agencyCandidate');

class AgencyCandidateApiAgency {
	static add (userId: number) {
		return client.post('', { userId });
	}

	static addMutiple (userIds: number[]) {
		return client.post('multiple', { userIds });
	}

	static grid (agencyPagedListParameters: IAgencyCandidatePagedListParameters) {
		return client.post<IPagedList<IUserCandidateModel>>('grid', agencyPagedListParameters);
	}

	static getDetails (userId: number) {
		return client.get<IUserCandidateDetailsModel>(userId.toString());
	}

	static delete (userIds: number[]) {
		return client.post('delete', { userIds });
	}
}

export default AgencyCandidateApiAgency;
